import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";

export type InvalidMatter = {
  matter_id: string;
  matter_number: string;
  case_name: string;
};

interface ExportValidationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invalidMatters: InvalidMatter[];
  onProceed: () => void;
  onCancel: () => void;
}

export const ExportValidationDialog: React.FC<ExportValidationDialogProps> = ({
  open,
  onOpenChange,
  invalidMatters,
  onProceed,
  onCancel,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Export Warning</DialogTitle>
          <DialogDescription>
            Please review the following before exporting:
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
            <p className="text-sm text-yellow-800 font-medium mb-2">
              ⚠️ {invalidMatters.length === 1
                ? "This matter may not be assigned to you or is inactive:"
                : "These matters may not be assigned to you or are inactive:"}
            </p>
            <ul className="text-sm text-yellow-700 space-y-2">
              {invalidMatters.map((m) => (
                <li key={m.matter_id} className="border-l-2 border-yellow-300 pl-2">
                  <span className="font-medium">{m.matter_number}</span>
                  <br />
                  <span className="text-yellow-600">{m.case_name}</span>
                </li>
              ))}
            </ul>
          </div>
          <p className="text-sm text-gray-600">
            Are you sure you want to export time to {invalidMatters.length === 1 ? "this matter" : "these matters"}?
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onProceed}>
            Export Anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
